<template>
  <v-container fluid class="monitorSite px-4">
    <br />
    <h1><a :href="'#/admin/reports/' + reportId" @click="reportMain">{{ this.reportTitle }}</a> - Details Page</h1>

    <div flex-nowrap class="buttons-left">
        <v-btn class="button" color="primary" v-on:click="sizeColumnsToFit()">Fit to Page</v-btn>
        <v-btn class="button" color="primary" v-on:click="autoSizeColumns(true)">Auto-size (Data Only)</v-btn>
        <v-btn class="button" color="primary" v-on:click="autoSizeColumns(false)">Auto-size (All)</v-btn>
    </div>

    <div style="width: 100%; height: 70vh; border: 1px solid">
      <ag-grid-vue
        id="myGrid"
        @grid-ready="onGridReady"
        style="width: 100%; height: 100%;"
        class="ag-theme-balham center-box elevation-2"
        :columnDefs="columnDefs"
        :rowData="rowData"
        @rowDoubleClicked="onRowDoubleClicked"
        :gridOptions="gridOptions"
        :colResizeDefault="colResizeDefault"
      ></ag-grid-vue>
    </div>

  </v-container>
</template>

<script>
// @ is an alias to /src
import { adminService } from "@/services/adminService.js";
import router from "@/router";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "ReportDetail",
  data: () => ({
    gridOptions: null,
    gridApi: null,
    columnApi: null,
    reportId: null,
    recordDataId: null,
    reportTitle: null,
    columnDefs: [],
    rowData: [],
    chartData: [],
    columnFieldNames: []
  }),
  components: {
    'ag-grid-vue': AgGridVue
  },
  created () {
    this.reportId = this.$route.params.reportId;
    this.recordDataId = this.$route.params.recordDataId;
  },
  beforeMount () {
    this.gridOptions = {};
  },
  mounted () {
    let me = this;

    me.gridApi = me.gridOptions.api;
    me.gridColumnApi = me.gridOptions.columnApi;

    adminService
    .getReportRecordDetails(me.reportId, me.recordDataId)
    .then(function (resp) {
      // console.log('res.data = ' + JSON.stringify(resp.data));
      me.reportTitle = resp.data.reportName;

      for (var i = 0; i < resp.data.columnNames.length; i++) {
        var tmpColumnDef = {};
        // console.log('resp.data.fields[' + i + '] = ' + resp.data.columnNames[i]);
        tmpColumnDef.field = resp.data.columnNames[i];
        me.columnFieldNames.push(resp.data.columnNames[i]);
        // console.log('resp.data.columns[' + i + '] = ' + resp.data.columnLabels[i]);
        tmpColumnDef.headerName = resp.data.columnLabels[i];
        tmpColumnDef.sortable = true;
        tmpColumnDef.filter = true;
        tmpColumnDef.resizable = true;
        tmpColumnDef.cellClass = "text-left";
        me.columnDefs.push(tmpColumnDef);
      }

      me.rowData = resp.data.detailData;
      // console.log('me.rowData = ' + JSON.stringify(me.rowData));
    })
    .catch(function (err) {
      console.error(err);
    });
  },
  methods: {
    sizeColumnsToFit () {
      this.gridApi.sizeColumnsToFit();
    },
    autoSizeColumns (header) {
       this.gridColumnApi.autoSizeColumns(this.columnFieldNames, header);
    },
    reports () {
      router.push({ name: 'reports' });
    },
    reportMain () {
      router.push({
        name: "admin.reportmain",
        params: { reportId: this.reportId }
      });
    }
  }
}

</script>

<style scoped>
.buttons-left {
  text-align: left;
}
.button {
  max-height:25px;
  margin: 10px 10px 10px 0px;
}
h1 {
  margin: 0px 0 20px 0;
}
</style>
